import { i18n } from '@lingui/core';

export interface UserDetailsPageParams extends Record<string, string | undefined> {
  userId: string
}
export const ROUTE_PARAM_IDENTIFIER = ':userId';
export const ROUTE_PATH = `/admin/users/details/${ROUTE_PARAM_IDENTIFIER}`;
export const TITLE = i18n._('Users');
